import React, { useCallback } from 'react';
import { Box, TextV2 } from '@withjoy/joykit';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { useHotelRoutePaths } from '@shared/utils/accommodations/hotelRoutes';
import { Bed, Bell } from '@withjoy/joykit/icons';
import { GUEST_GUIDE_UTM } from './guestGuideUtm.constants';
import { useCarbonIframeLinkProps } from '@shared/hooks/useCarbonIframeLinkProps';

type HotelDealsActionProps = Readonly<{
  isAttending: boolean;
  showExperimentLabel?: boolean;
  showBellIcon?: boolean;
  countdownDays?: number;
  isEventDay?: boolean;
}>;

export const HotelDealsAction: React.FC<HotelDealsActionProps> = ({ isAttending, showExperimentLabel, showBellIcon, countdownDays, isEventDay }) => {
  const { eventHandle } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const hotelRoutePaths = useHotelRoutePaths();

  const handleClick = useCallback(() => {
    telemetry.clickBrowseHotels();
  }, [telemetry]);
  const carbonIframeLinkProps = useCarbonIframeLinkProps();

  return (
    <GuestGuideActionButton
      icon={
        showBellIcon ? (
          <Bell
            size={32}
            color="#4951EF"
          />
        ) : (
          <Bed size={32} />
        )
      }
      as="a"
      href={hotelRoutePaths.bookYourStay.buildRelativeUrl(eventHandle || '', GUEST_GUIDE_UTM)}
      onClick={handleClick}
      {...carbonIframeLinkProps}
    >
      <Box>
        <TextV2 typographyVariant="button2">
          {showExperimentLabel ? tq`Guest Only Hotel Deals` : isAttending ? tq`Book Event-Exclusive Stays` : tq`See Event-Exclusive Stays`}
        </TextV2>
        {isEventDay && (
          <TextV2
            marginTop={2}
            typographyVariant="label2"
            color="mono12"
          >
            {tq`It's the big day - book your stay if you haven't already.`}
          </TextV2>
        )}
        {countdownDays != null && !isEventDay && (
          <TextV2
            marginTop={2}
            typographyVariant="label2"
            color="mono12"
          >
            {tq.plural(countdownDays, {
              one: tq`1 day to the big event - book your stay, before rooms sell out.`,
              other: tq`${countdownDays} days to the big event - book your stay, before rooms sell out.`,
            })}
          </TextV2>
        )}
      </Box>
    </GuestGuideActionButton>
  );
};
